import { render } from "./DatesSearch.vue?vue&type=template&id=04c70c12&scoped=true"
import script from "./DatesSearch.vue?vue&type=script&lang=js"
export * from "./DatesSearch.vue?vue&type=script&lang=js"

import "./DatesSearch.vue?vue&type=style&index=0&id=04c70c12&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c70c12"]])

export default __exports__